// extracted by mini-css-extract-plugin
var _1 = "AssignmentsList__list--WnSny";
var _2 = "AssignmentsList__row--PR50z";
var _3 = "AssignmentsList__title--JoobN";
export { _1 as "list", _2 as "row", _3 as "title" }
